function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header---Normal",
  transform: "translate(-1300.000000, -25.000000)",
  fill: "#9399AC"
}, /*#__PURE__*/React.createElement("g", {
  id: "Header"
}, /*#__PURE__*/React.createElement("g", {
  id: "Right",
  transform: "translate(1083.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-802",
  transform: "translate(217.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.5546,19 C6.2476,20.19 7.5236,21 8.9996,21 C10.4766,21 11.7516,20.19 12.4456,19 L5.5546,19 Z",
  id: "Fill-121"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.966,15 C13.745,13.998 13,12.486 13,10.838 L13,6 C13,3.795 11.206,2 9,2 C6.795,2 5,3.795 5,6 L5,10.838 C5,12.486 4.255,13.998 3.035,15 L14.966,15 Z M18,17 L0,17 L0,14.279 L0.684,14.053 C2.069,13.589 3,10.299 3,8.838 L3,6 C3,2.691 5.692,0 9,0 C12.309,0 15,2.691 15,6 L15,8.838 C15,10.299 15.931,13.589 17.317,14.053 L18,14.279 L18,17 Z",
  id: "Fill-122"
}))))));

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "21px",
    viewBox: "0 0 18 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bell.476e19ce.svg";
export { ForwardRef as ReactComponent };